// extracted by mini-css-extract-plugin
export default {"status":"Status_status__WheYE","status__wrapper":"Status_status__wrapper__ddsiB"};